import { useParams } from "react-router-dom"
import { FavoriteGameList } from "../components/FavoriteGameList"
import { SectionGameList } from "../components/SectionGameList"

const SubPageGameSection = () => {
    const { sectionId = "" } = useParams<{ sectionId: string }>()
    return sectionId === "favorite" ? <FavoriteGameList /> : <SectionGameList />
}

export { SubPageGameSection }
